<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.w_nc_supplier_compliance' | trans" [accent]="bestTaux()" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
    @if (showPeriodFilter()) {
      <vl-widget-period-filters
        [(timeScale)]="timeScale"
        [showPeriod]="false"
        [showComparison]="false"/>
    }
  </vl-widget-title>

  @if (isLoading()) {
    <div class="flex-col gap-12 widget-content">
      <ngx-skeleton-loader count="5" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (hasData()) {
    <div class="flex-col w100 widget-content fade-in" style="overflow: hidden; gap: 8px">
      <span class="caption on-background-alt">{{ 'dashboard_ui.nc_titre_pires' | trans }}</span>

      <div class="flex-col gap-4 grow" style="overflow: auto; min-height: 0">
        @for (s of worstTop5(); track s.tiersId) {
          <div class="row-supplier">
            <span class="grow body-2 ellipsis" [matTooltip]="s.denomination">{{ s.denomination }}</span>
            <span class="caption-2 on-background-alt shrink-0 nb-nc">{{ s.nbNc }} NC</span>
            <span class="taux-pill shrink-0"
                  [class.taux-bad]="s.tauxConformite != null && s.tauxConformite < 90"
                  [class.taux-warn]="s.tauxConformite != null && s.tauxConformite >= 90 && s.tauxConformite < 95"
                  [class.taux-ok]="s.tauxConformite != null && s.tauxConformite >= 95"
                  [class.taux-na]="s.tauxConformite == null">
              {{ fmtTaux(s.tauxConformite) }}
            </span>
          </div>
        } @empty {
          <span class="caption on-disabled">—</span>
        }
      </div>

      <div class="flex-row align-center" style="justify-content: flex-end">
        <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
